import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import HTMLContent from './HTMLContent';

export default function Tip({ tip, describedBy }) {
  const [open, setOpen] = useState(false);
  const titleId = describedBy ? `${describedBy}-tip-title` : 'tip-dialog-title';
  if (!tip) return null;
  return <>
    <Tooltip title="Show tip"><IconButton type="button" onClick={() => setOpen(true)} aria-label="Show tip" aria-describedby={describedBy}><LightbulbOutlinedIcon /></IconButton></Tooltip>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth aria-labelledby={titleId}>
      <DialogTitle id={titleId} component="h2">Tip</DialogTitle>
      <DialogContent><HTMLContent content={tip} /></DialogContent>
      <DialogActions><Button autoFocus onClick={() => setOpen(false)}>Close</Button></DialogActions>
    </Dialog>
  </>;
}
